<div class="password-page">
    <div class="password-wrapper">
        <mat-card class="password-card">
            <div class="password-logo-wrapper">
                <img src="/logo.png" alt="copago Logo" class="password-logo" />
            </div>

            <div class="password-header">
                <div class="header-icon">
                    <mat-icon>password</mat-icon>
                </div>

                <h1>Passwort aktualisieren</h1>

                @if (hasValidResetLink()) {
                <p>Bitte vergeben Sie ein neues Passwort für Ihr Benutzerkonto.</p>
                } @else {
                <p>Der Link zum Zurücksetzen des Passworts ist ungültig oder unvollständig.</p>
                }
            </div>

            @if (hasValidResetLink()) {
            <form class="password-form" [formGroup]="form" (ngSubmit)="submit()">
                <div class="form-field-group">
                    <label class="custom-label" for="newPassword">Neues Passwort</label>

                    <mat-form-field appearance="outline" class="full-width custom-field">
                        <input id="newPassword" matInput formControlName="newPassword"
                            [type]="hidePassword() ? 'password' : 'text'" autocomplete="new-password" />

                        <button mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility()"
                            aria-label="Passwort anzeigen oder verbergen">
                            <mat-icon>{{ hidePassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
                        </button>
                    </mat-form-field>

                    <div class="hint">Das Passwort muss mindestens 8 Zeichen lang sein.</div>

                    @if (form.controls.newPassword.touched && form.controls.newPassword.hasError('required')) {
                    <div class="field-error">Bitte geben Sie ein neues Passwort ein.</div>
                    }

                    @if (form.controls.newPassword.touched && form.controls.newPassword.hasError('minlength')) {
                    <div class="field-error">Das Passwort muss mindestens 8 Zeichen lang sein.</div>
                    }
                </div>

                <div class="form-field-group">
                    <label class="custom-label" for="confirmPassword">Neues Passwort bestätigen</label>

                    <mat-form-field appearance="outline" class="full-width custom-field">
                        <input id="confirmPassword" matInput formControlName="confirmPassword"
                            [type]="hideConfirmPassword() ? 'password' : 'text'" autocomplete="new-password" />

                        <button mat-icon-button matSuffix type="button" (click)="toggleConfirmPasswordVisibility()"
                            aria-label="Passwortbestätigung anzeigen oder verbergen">
                            <mat-icon>{{ hideConfirmPassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
                        </button>
                    </mat-form-field>

                    @if (form.controls.confirmPassword.touched && form.controls.confirmPassword.hasError('required')) {
                    <div class="field-error">Bitte bestätigen Sie das neue Passwort.</div>
                    }

                    @if (form.controls.confirmPassword.touched && form.hasError('passwordsNotMatching')) {
                    <div class="field-error">
                        Das neue Passwort und die Bestätigung stimmen nicht überein.
                    </div>
                    }
                </div>

                @if (serverError()) {
                <div class="server-error">
                    {{ serverError() }}
                </div>
                }

                @if (successMessage()) {
                <div class="success-message">
                    {{ successMessage() }}
                </div>
                }

                <button mat-flat-button type="submit" class="primary-button" [disabled]="isSubmitting()">
                    @if (!isSubmitting()) {
                    <span>Passwort aktualisieren</span>
                    } @else {
                    <mat-spinner diameter="20"></mat-spinner>
                    }
                </button>
            </form>
            } @else {
            <a routerLink="/login" class="primary-link-button">Zur Anmeldung</a>
            }
        </mat-card>
    </div>
</div>